import { datadogLogs } from '@datadog/browser-logs';
import logo from 'assets/img/Viooh.png';

type ShowBrowserNotificationProps = {
  title: string;
  body: string;
  redirectPath?: string;
  onClick?: () => void;
};

export const showBrowserNotification = async ({
  title,
  body,
  redirectPath,
  onClick,
}: ShowBrowserNotificationProps): Promise<boolean> => {
  if (!('Notification' in window)) {
    datadogLogs.logger.error('This browser does not support desktop notifications.');
    return false;
  }

  if (Notification.permission !== 'granted') {
    await Notification.requestPermission();
  }

  if (Notification.permission !== 'granted') {
    return false;
  }

  const notification = new Notification(title, { body, badge: logo, icon: logo });

  notification.onclick = () => {
    window.focus();
    notification.close();

    if (onClick) {
      onClick();
    } else if (redirectPath) {
      window.location.href = `${window.location.origin}${redirectPath}`;
    }
  };

  return true;
};
